import { BaseTable, Button, Icons, Sentiments } from "@sede-x/shell-ds-react-framework";
import { TMovement } from "ticketing/ticketing.types";

type MovementInfoFieldsProps = {
  movement: TMovement;
  onClose: () => void;
};

export const MovementInfoFields = ({ movement, onClose }: MovementInfoFieldsProps) => {
  const fields = movement.infoFields;
  const columns = [
    {
      header: "Name",
      accessorKey: "name"
    },
    {
      header: "Value",
      accessorKey: "value"
    }
  ];
  return (
    <div className={"content-wrapper"}>
      <div className={"grid-wrapper"}>
        <div className={"card-container"}>
          <div style={{ marginTop: "10px", textAlign: "right" }}>
            <Button
              sentiment={Sentiments.Negative}
              icon={<Icons.Cross />}
              onClick={onClose}
              size="small">
              Close
            </Button>
          </div>
          <BaseTable
            data={fields}
            columns={columns}
            style={{
              flex: 1,
              width: "100%",
              height: "100%"
            }}
          />
        </div>
      </div>
    </div>
  );
};
